import { useState } from "react";
import {
	DndContext,
	DragOverlay,
	closestCenter,
	PointerSensor,
	TouchSensor,
	useSensors,
	useSensor,
} from "@dnd-kit/core";
import { arrayMove, SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";

import PlusIcon from "../../icons/plus.svg";

import Reason from "./Reason";

function PlayerReasonsToPlay(props) {
	const [activeId, setActiveId] = useState(null);

	const style = {
		reasonContainer:
			"relative m-1 p-1 w-96 flex flex-col justify-between border border-gray-400 text-center shadow rounded-lg hover:bg-gray-200",
		author: "font-bold",
		modal: "mx-auto my-44 relative w-[30%] h-60 rounded-lg overflow-hidden border-4",
		icon: {
			container:
				"absolute top-2 right-3 m-auto p-[3px] size-fit border border-black/90 text-center rounded-full cursor-pointer",
			icon: "w-[12px]",
		},
		reasons: "max-h-96 p-2 overflow-y-scroll",
	};

	const sensors = useSensors(useSensor(PointerSensor), useSensor(TouchSensor));

	function handleDragStart(event) {
		const { active } = event;
		setActiveId(active.id);
	}

	function handleDragEnd(event) {
		const { active, over } = event;

		if (active.id !== over.id) {
			const oldIndex = props.reasonToPlay.reasons.findIndex(reason => reason.id === active.id);
			const newIndex = props.reasonToPlay.reasons.findIndex(reason => reason.id === over.id);

			const reasons = arrayMove(props.reasonToPlay.reasons, oldIndex, newIndex);

			const updatedReasons = reasons.map((reason, index) => ({
				...reason,
				priority: index,
			}));

			const priorityList = updatedReasons.map(reason => ({ reasonId: reason.id, priority: reason.priority }));
			const newReasonToPlay = {
				...props.reasonToPlay,
				reasons: updatedReasons,
			};
			props.updateReasonPriorities(newReasonToPlay, priorityList);
		}
	}

	return (
		<div className={style.reasonContainer}>
			{props.player.id === props.reasonToPlay.id ? (
				<div aria-label="Add Reason" className={style.icon.container} onClick={props.openEditReasonModal}>
					<PlusIcon className={style.icon.icon} />
				</div>
			) : null}
			<div className="flex flex-col flex-wrap justify-around">
				<div className={style.author}>{props.reasonToPlay.playerName}</div>
				{/* Check if the current player owns this set of Reasons to Play. If so make draggable */}
				{props.player.id === props.reasonToPlay.id ? (
					<>
						<DndContext
							sensors={sensors}
							collisionDetection={closestCenter}
							onDragStart={handleDragStart}
							onDragEnd={handleDragEnd}>
							<SortableContext items={props.reasonToPlay.reasons} strategy={verticalListSortingStrategy}>
								<div className={style.reasons}>
									{props.reasonToPlay.reasons.map(reason => (
										<Reason
											key={reason.id}
											player={props.player}
											ownerId={props.reasonToPlay.id}
											reason={reason}
											openEditReasonForm={props.openEditReasonForm}
											openConfirmActionModal={props.openConfirmActionModal}
										/>
									))}
								</div>
							</SortableContext>
						</DndContext>
						<DragOverlay>{activeId ? <Reason id={activeId} /> : null}</DragOverlay>
					</>
				) : (
					<div className={style.reasons}>
						{props.reasonToPlay.reasons.map(reason => (
							<Reason
								key={reason.id}
								player={props.player}
								ownerId={props.reasonToPlay.id}
								reason={reason}
								openEditReasonForm={props.openEditReasonForm}
								openConfirmActionModal={props.openConfirmActionModal}
								handlePin={props.handlePin}
							/>
						))}
					</div>
				)}
			</div>
		</div>
	);
}

export default PlayerReasonsToPlay;
